/* istanbul ignore file */
import Captions from './Captions';

export default Captions;
